import React from 'react';
import { Grid, Typography } from '@mui/material';
import getGlossary from '../glossary';

const Glossary = ({ attr }) => (
  <div className="leaf location">
    <Typography variant="h5" className="name">
      {getGlossary()[attr].name}
    </Typography>

    <Grid size={{ xs: 2 }}>
      <Typography variant="h6">Definition:</Typography>
    </Grid>
    <Grid size={{ xs: 8 }} className="static-attr">
      <p>{getGlossary()[attr].definition}</p>
    </Grid>

    <Grid size={{ xs: 2 }}>
      <Typography variant="h6">Purpose:</Typography>
    </Grid>
    <Grid size={{ xs: 8 }} className="static-attr">
      <p>{getGlossary()[attr].purpose}</p>
    </Grid>
  </div>
);

export default Glossary;
